function MainComponent({ buttonPartnerBridge, buttonDWP }) {

    return (
        <div>
            <div className="header-utility">
                <div className="header-utility-inner">
                    <ul className="header-utility-list sub">
                    </ul>
                </div>
            </div>
            <main className="site-main">
                <section className="sct-primary">
                    <div className="mod-hdg-l1">
                        <div className="inner">
                            <h1 className="hdg">Web問い合わせシステム</h1>
                            <span className="sub of-top">NEC ファーストコンタクトセンター</span>
                        </div>
                    </div>
                    <div className="str-outer">
                        <div className="str-inner">
                            <h4 className="mod-hdg-l2-02">
                                <span>Web問い合わせシステム ご案内</span>
                            </h4>
                            <div className="mod-txt">
                                <p>
                                    NEC ファーストコンタクトセンター Web問い合わせシステムでは、ビジネスPC、Express5800、iStorage、ソフトウェア製品について
                                    パートナー様/NECグループ/社内からの各種お問い合わせに対応いたします。詳細はログイン後の「ご利用にあたって」をご確認ください。
                                </p>
                            </div>
                            <div className="mod-list-02 of-notice">
                                <ul className="list">
                                    <li>
                                        <span className="mark"><em>※</em></span>
                                        <div className="content">
                                            <div className="mod-txt">
                                                <p><em>Web問い合わせシステムのブラウザ環境はMicrosoft Edge, Google Chromeの最新バージョンです。</em></p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <h3 className="mod-hdg-l3-02">
                                <span>Web問い合わせシステムへログイン</span>
                            </h3>
                            <div className="mod-list-02 of-notice">
                                <table>
                                    <tbody>
                                        <tr>
                                            <td><button onClick={() => buttonPartnerBridge()}>販売店様・パートナー様はこちら</button></td>
                                            <td><button onClick={() => buttonDWP()}>NECグループの方はこちら</button></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    );
}


export default MainComponent;